// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* StartWindow overlay to cover the entire screen */
.start-window-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7); /* Dark overlay */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 50; /* Ensures it's above everything */
  }
  
  /* StartWindow modal box */
  .start-window-modal {
    background: white;
    padding: 1.5rem;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    width: 350px;
  }
  
  /* StartWindow OK button */
  .start-window-button {
    margin-top: 1rem;
    padding: 0.5rem 1rem;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.2s;
  }
    
  .start-window-button:hover {
    background: #0056b3;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/startWindow.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B,EAAE,iBAAiB;IACjD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW,EAAE,kCAAkC;EACjD;;EAEA,0BAA0B;EAC1B;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,YAAY;EACd;;EAEA,0BAA0B;EAC1B;IACE,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":["/* StartWindow overlay to cover the entire screen */\n.start-window-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.7); /* Dark overlay */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 50; /* Ensures it's above everything */\n  }\n  \n  /* StartWindow modal box */\n  .start-window-modal {\n    background: white;\n    padding: 1.5rem;\n    border-radius: 10px;\n    text-align: center;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n    width: 350px;\n  }\n  \n  /* StartWindow OK button */\n  .start-window-button {\n    margin-top: 1rem;\n    padding: 0.5rem 1rem;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background 0.2s;\n  }\n    \n  .start-window-button:hover {\n    background: #0056b3;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
